import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	center: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		margin: '30px 0',
	},
	container: {
		alignItems: 'center',
		color: '#0D0F11',
		display: 'flex',
		fontSize: 12,
		justifyContent: 'space-between',
		margin: '30px 0',
	},
	copy: {
		cursor: 'pointer',
		paddingLeft: 8,
	},
	importData: {
		padding: '0px 10px',
		width: '20%',
	},
	importDataLarge: {
		alignItems: 'center',
		display: 'flex',
		padding: '0px 10px',
		width: '30%',
	},
	importDataSmall: {
		padding: '0px 10px',
		width: '10%',
	},
});
